import React from "react";
import Select, {
  StylesConfig,
  MultiValue,
  ActionMeta,
  GroupBase,
} from "react-select";

export interface OptionType {
  value: string;
  label: string;
}

const customStyles: StylesConfig<OptionType, true, GroupBase<OptionType>> = {
  control: (provided: any, state: any) => ({
    ...provided,
    borderColor: "#ced4da",
    borderRadius: "0.375rem",
    boxShadow: state.isFocused ? "0 0 0 0.25rem rgba(153, 116, 4, 0.25)" : null,
    "&:hover": {
      borderColor: "#ccba82",
    },
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "rgba(153, 116, 4, 0.25)"
      : state.isFocused
      ? "#B3812D"
      : "white",
    color: state.isFocused ? "white" : "grey",
    "&:active": {
      backgroundColor: "rgba(153, 116, 4, 0.25)",
    },
  }),
  multiValue: (provided: any) => ({
    ...provided,
    backgroundColor: "rgba(251, 229, 132, 0.5)",
    borderRadius: "7.2px",
    border: "2px solid #997404",
    color: "black !important",
  }),
  multiValueLabel: (provided: any) => ({
    ...provided,
    color: "black",
  }),
  multiValueRemove: (provided: any) => ({
    ...provided,
    color: "black",
    "&:hover": {
      backgroundColor: "rgba(153, 116, 4, 0.25)",
      color: "black",
    },
  }),
  menu: (provided: any) => ({
    ...provided,
    marginTop: "0rem",
    paddingTop: "0rem",
    borderBottomLeftRadius: "5px",
    borderBottomRightRadius: "5px",
    borderTopRightRadius: "0px",
    borderTopLeftRadius: "0px",
    overflow: "hidden",
  }),
  menuList: (provided: any) => ({
    ...provided,
    borderBottomLeftRadius: "5px",
    borderBottomRightRadius: "5px",
    marginTop: "0rem",
    paddingTop: "0rem",
    marginBottom: "0rem",
    paddingBottom: "0rem",
  }),
};

interface CustomMultiSelectProps {
  options: OptionType[];
  value: OptionType[];
  onChange: (
    newValue: MultiValue<OptionType>,
    actionMeta: ActionMeta<OptionType>
  ) => void;
  placeholder?: string;
  isDisabled?: boolean;
  zIndex?: number;
}

const CustomMultiSelect: React.FC<CustomMultiSelectProps> = ({
  options,
  value,
  onChange,
  placeholder,
  isDisabled,
  zIndex = 3,
}: CustomMultiSelectProps): React.ReactElement => (
  <Select<OptionType, true>
    options={options}
    styles={{
      ...customStyles,
      container: (provided: any) => ({
        ...provided,
        zIndex: zIndex,
      }),
    }}
    value={value}
    onChange={onChange}
    placeholder={placeholder}
    isMulti={true}
    isDisabled={isDisabled}
  />
);

export default CustomMultiSelect;
